import { taskCategoriesStore } from '../taskCategoriesStore';
import { createStoreDispatcher, type StoreDispatcher } from '../../commands/storeDispatcher';
import type { CategoryCommand } from './categoryCommands';

let dispatcher: StoreDispatcher<CategoryCommand> | null = null;
let initialized = false;

export function initCategoryDispatcher(): StoreDispatcher<CategoryCommand> {
  if (initialized) return dispatcher!;
  initialized = true;
  dispatcher = createStoreDispatcher<CategoryCommand>(taskCategoriesStore);
  return dispatcher;
}

export function getCategoryDispatcher(): StoreDispatcher<CategoryCommand> {
  if (!dispatcher) {
    throw new Error('Category dispatcher not initialized. Call initCategoryDispatcher() first.');
  }
  return dispatcher;
}
